Vue.component('currentBattle', {
  template: templates.currentBattle,
  data() {
    return {
      model: {
        battle: null,
        hasResults: false
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;

      battleService.getActive()
        .then(function (response) {

          let data = response.data[0];

          if (data.twitch1DisplayName == null || data.twitch2DisplayName == null) {
            c.getTwitchName(data);
          } else {
            data.user1TwitchDisplayName = data.twitch1DisplayName;
            data.user2TwitchDisplayName = data.twitch2DisplayName;
            c.model.battle = data
            c.model.hasResults = true;
          }

          setTimeout(function() {
            c.get();
          }, 5000);
        })
        .catch(function (error) {
          c.model.hasResults = false;
          setTimeout(function() {
            c.get();
          }, 5000);
        });
    }, 
    getTwitchName(data) {
      const c = this;
      let url = `${apiUrl}users?`;
      for (let i in data) {
        url = `${url}id=${data.user1TwitchId}&id=${data.user2TwitchId}&`;
      }

      axios.get(url, {
          headers: { 
            'Client-ID': clientId,
            'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
          }
        })
        .then(function (response) {
          for (let d of response.data.data) {
            if (data.user1TwitchId == d.id) {
              data.user1TwitchDisplayName = d.display_name;
            } else if (data.user2TwitchId == d.id) {
              data.user2TwitchDisplayName = d.display_name;
            }
          }
          c.model.battle = data
          c.model.hasResults = true;
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            authentication.refreshAccessToken({callback: function() {
              c.getTwitchName(data);
            }});
          }
        });
    },
    queue(id) {
      const c = this;

      var result = confirm("Are you sure you want to stop this battle?");
      if (result == true) {
        battleService.requeue({id: id})
          .then(function (response) {
            c.model.hasResults = false;
            c.model.battle = null;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },
    cancel(id) {
      const c = this;

      var result = confirm("Are you sure you want to stop this battle?");
      if (result == true) {
        battleService.cancel({id: id})
          .then(function (response) {
            c.model.hasResults = false;
            c.model.battle = null;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    }
  }
});